import React, { memo } from 'react';
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';
import { CONTEXT } from '../../config';
import styles from './WallpaperMinePay.module.less';
import { logging, logPostInfo } from '../../actions/log';
import WallpaperCard from '../../components/WallpaperCard/WallpaperCard';
import WpCardPkg from '../../components/WallpaperCard/WpCardPkg';
import Default from '../../static/wp/wp_pay.png';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(props => {
  const { mineInfo = {}, logInfo = {}, active = 'paylist', handleCancel = () => {} } = props;
  const history = useHistory();
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);

  return (
    <div className={styles.mine_pay}>
      {mineInfo.list.map((item, index) => {
        return (
          <div className={styles.pay_item} key={index}>
            <div className={styles.pay_item_img}>
              {item.type === '1' && (
                <WallpaperCard
                  wallpaper={item.wallpaperInfo}
                  key={item.wallpaperInfo.wallpaperId}
                  cardInfo={{
                    pageSource: 'minePay',
                    pageTage: active || 'paylist',
                    classType: 'default_image',
                    isCollect: true,
                    isWallpaper: true,
                    isPreview: true,
                    isDeleteColl: active === 'collect',
                    isDeleteUsed: active === 'setup',
                    deleteCallback: handleCancel,
                    isSingleWp: true,
                    isPayCard: true,
                    isHasPayPkg: true,
                  }}
                  logInfo={{ source: `Wallpaper_Mine||${active}` }}
                />
              )}

              {item.type === '2' && (
                <WpCardPkg cardInfo={item} logInfo={{ source: `Wallpaper_Mine||${active}` }} />
              )}
              {item.type === '3' && (
                <div className={styles.pay_item_img}>
                  <img src={Default} />
                </div>
              )}
            </div>
            <div className={styles.pay_item_info}>
              <div className={styles.pay_item_info_header}>订单信息</div>
              <div className={styles.pay_item_info_line}>
                <div className={styles.pay_item_info_line_left}>
                  {item.type === '1' && '壁纸ID'}
                  {item.type === '2' && '壁纸包'}
                  {item.type === '3' && '订单信息'}
                </div>
                <div className={styles.pay_item_info_line_right}>
                  {item?.type === '1' && item.wallpaperInfo && item.wallpaperInfo.wallpaperId}
                  {item?.type === '2' && item.rankInfo && item.rankInfo.name}
                  {item?.type === '3' && item.skuName}
                </div>
              </div>
              <div className={styles.pay_item_info_line}>
                <div className={styles.pay_item_info_line_left}>订单号</div>
                <div className={styles.pay_item_info_line_right}>{item.orderId}</div>
              </div>
              <div className={styles.pay_item_info_line}>
                <div className={styles.pay_item_info_line_left}>购买时间</div>
                <div className={styles.pay_item_info_line_right}>
                  {item.successTime.substring(0, item.successTime.length - 3)}
                </div>
              </div>
              <div className={styles.pay_item_info_line}>
                <div className={styles.pay_item_info_line_left}>支付价格</div>
                <div className={styles.pay_item_info_line_right}>
                  {(item.payAmount / 100).toFixed(2)}元
                </div>
              </div>
              <div className={styles.pay_item_info_line}>
                <div className={styles.pay_item_info_line_left}>支付方式</div>
                <div className={styles.pay_item_info_line_right}>
                  {item.payType === 'WX' ? '微信支付' : '支付宝支付'}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
});
